/* eslint-disable no-undef*/
import React, { Component, createRef } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { StyledModal, CustomTitle, ContentWrapper, NoGuests, AddBuddyButtonContainer, /*AddBuddyButtons*/ } from './styles';
import CSVList from './CSVList';
import Image from '../Image';
import { sendFriendRequest } from '../../redux/actions';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { /*WhiteDownloadIcon,*/ AdminCloseIcon, AdminDownloadIcon } from '../../utils/icons';
// import { CommonButtonBorder } from '../common/commonStyles';
import { Border } from '../Journeys/styles';
import { NameInitials } from '../Manager/styles';
import { fetchApi, getInitials } from '../../utils/methods';
import { GetRegisteredAttendedUsers } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { CommonButtonBorder } from '../common/commonStyles';

const headers = [
  { label: "First Name", key: "fname" },
  { label: "Last Name", key: "lname" },
  { label: "Email", key: "EMAIL" },
  { label: "Company Name", key: "company_name" },
  { label: "Department", key: "department" },
];

class AttendeesModal extends Component {
  constructor() {
    super();
    this.state = {
      attendees: [],
      page: 1,
      limit: 20,
      hasMore: true,
      isLoading: false,
      marginLeft: false,
      printAttendees: false,
      totalUsers:0,
      reportAttendees:[]

    }
    this.scrollRef = createRef();
  }

  // componentDidMount() {
  //   setTimeout(this.setState({ marginLeft: true }), 3000)
  // }

  componentDidMount() {
    this.setState({ marginLeft: true });
    this.fetchAttendees();

    this.scrollRef.current?.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.scrollRef.current?.removeEventListener('scroll', this.handleScroll);
  }
  

  fetchAttendees = async () => {
    const { page, limit, attendees, isLoading, hasMore } = this.state;
    const { eventId, type } = this.props;

    if (isLoading || !hasMore) return;

    this.setState({ isLoading: true });

    try {
      const response = await fetchApi(`${GetRegisteredAttendedUsers}/${eventId}/${type}/${page}/${limit}`, "GET");

      if(response?.status === 'success'){
        const resData = response?.data;
        const newUsers = resData?.user || [];
        const { current_page, total_pages, total_users } = resData?.pagination || {};
    
        this.setState({
          attendees: [...attendees, ...newUsers],
          page: current_page + 1,
          hasMore: current_page < total_pages,
          isLoading: false,
          totalUsers:total_users
        });

      }else{
        toast.error(res?.data?.message)
      }

    } catch (error) {
      console.error("Error fetching attendees:", error);
      this.setState({ isLoading: false });
    }
  };

  fetchReportAttendees = async () => {
    const { eventId, type } = this.props;

    this.setState({ isLoading: true });

    try {
      const response = await fetchApi(`${GetRegisteredAttendedUsers}/${eventId}/${type}`, "GET");

      if(response?.status === 'success'){
        const resData = response?.data;
        const newUsers = resData?.user || [];
    
        this.setState({
          reportAttendees: newUsers,
        },()=>{
          this.printAction(true)
        });

      }else{
        toast.error(res?.data?.message)
      }

    } catch (error) {
      console.error("Error fetching attendees:", error);
      this.setState({ isLoading: false });
    }
  };

  handleScroll = () => {
    const container = this.scrollRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (scrollTop + clientHeight >= scrollHeight - 10) {
      this.fetchAttendees();
    }
  };

  printAction = (bool) => {
    this.setState({
      printAttendees: bool
    })
  }

  render() {
    const { /*Attendees,*/ showModal, onHide, Title, /*isValidUser, sendFriendRequest,*/ t, /*role, eventType, eventAttendees*/isRegisteredUserPopup,isCompanyUsers } = this.props;
    const { marginLeft, printAttendees, attendees,totalUsers,reportAttendees } = this.state;

    return (
      <StyledModal 
        $width={"432px"} $height={"504px !important"}  show={showModal} onHide={() => onHide()}>
        <Modal.Header style={{background:"white" ,border:'none'}}>
          <CustomTitle>
            <div>
              {/* <span>Registered users <span className="attendeeCount">({attendees.length})</span></span> */}
              <span>{isCompanyUsers && 'Company'}{isRegisteredUserPopup ?  " Registered User " :" Attendees " }<span className="attendeeCount"> ({totalUsers})</span></span>

              <span className="closeImage">
                {/* <div className="print" onClick={() => this.printAction(true)}>
               upload
                </div> */}
                <div onClick={() => onHide()}>
                  {AdminCloseIcon()}
                </div>
              </span>
            </div>
          </CustomTitle>

        </Modal.Header>
        <Border style={{width:"93%", background: '#EFEFEF', margin: '4px 16px 20px 16px' }} />
       
        <Modal.Body ref={this.scrollRef} style={{ overflowY: 'auto', maxHeight: '420px' }}>
          {
            attendees.length > 0 ?
              attendees.map((attendee, index) => (
                <ContentWrapper key={index} marginLeft={marginLeft} isRowPadding={"4px 24px"}>
                  <div>
                    <div className="image">
                      {attendee.profile_image !== "profile-Image/default.png" ? (
                        <Image image={attendee.profile_image} alt={attendee.full_name} />) : 
                        <NameInitials> {getInitials(`${attendee.fname} ${attendee.lname}`)}</NameInitials>}
                    </div>
                    <div className="attendeeInfo">
                      <span>{`${attendee.fname} ${attendee.lname}`}</span>
                      {/* <p>{t(attendee.department)}</p> */}
                    </div>
                    <AddBuddyButtonContainer background={'#69c2ff'}>
                      {/* {
                        attendee.request_status === null ?
                          <AddBuddyButtons
                            onClick={() => sendFriendRequest(attendee.uid)} background={'rgb(253, 113, 117)'}>{t("Add Buddy")}</AddBuddyButtons> : attendee.request_status === "Accepted" ?
                            <AddBuddyButtons background={'rgb(159, 201, 137)'}>{t("Buddy")}</AddBuddyButtons > : attendee.request_status === "Pending" ?
                              <AddBuddyButtons background={'rgb(246, 180, 121)'}>{t("Pending")}</AddBuddyButtons > : ""
                      } */}
                    </AddBuddyButtonContainer>
                  </div>
                </ContentWrapper>
              )) :
              <NoGuests>{isRegisteredUserPopup ? t("No Registered Users") : t("No Attendees")}</NoGuests>
          }
        </Modal.Body>

        {attendees.length > 0 ? <div className="downloadButton">
          <CommonButtonBorder width="200px" height='40px' margin="16px 0 0 0" onClick={()=>this.fetchReportAttendees()}>
            {AdminDownloadIcon()}
            Download
          </CommonButtonBorder>
        </div>:null}
        {/* <div className="downloadButton">
          <CommonButtonBorder width="200px" height="48px"
            onClick={() => this.printAction(true)}
            margin="auto auto auto 0px">
            {WhiteDownloadIcon("#F37A65")}
            Download
          </CommonButtonBorder>
        </div> */}
        {printAttendees &&
          <CSVList Title={`${Title.replace(/ /g, "_")}_Attendees`} removeCSVData={this.printAction} data={reportAttendees} headers={headers} />
        }
      </StyledModal>
    )
  }
}

AttendeesModal.propTypes = {
  Attendees: PropTypes.array.isRequired,
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  Title: PropTypes.string,
  isValidUser: PropTypes.bool,
  sendFriendRequest: PropTypes.func,
  t: PropTypes.func,
  role: PropTypes.string,
  eventType: PropTypes.number,
  eventAttendees: PropTypes.array,
  isRegisteredUserPopup: PropTypes.bool,
  eventId:PropTypes.number,
  type:PropTypes.string,
  isCompanyUsers:PropTypes.string
};

const mapStateToProps = (state) => ({
  sentRequest: state.social.sentRequest
});

const mapDispatchToProps = (dispatch) => ({
  sendFriendRequest: (data) => dispatch(sendFriendRequest(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AttendeesModal));
